import {createContext} from 'react';

import {ONBOARDING_INITIAL_VALUE} from './onboarding-const';
import {OnboardingProviderType} from './onboarding-type';

export const OnboardingContext = createContext<OnboardingProviderType>(ONBOARDING_INITIAL_VALUE);
